import { render } from "./newOpportunity.vue?vue&type=template&id=ca0c17f2&scoped=true"
import script from "./newOpportunity.vue?vue&type=script&lang=js"
export * from "./newOpportunity.vue?vue&type=script&lang=js"

import "./newOpportunity.vue?vue&type=style&index=0&id=ca0c17f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0c17f2"]])

export default __exports__